import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import PrimeVue from "primevue/config";
import VueSweetalert2 from "vue-sweetalert2";
import ToastService from 'primevue/toastservice';
import { createGtm } from "vue-gtm";
import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "./assets/css/main.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/all.css";
import "/node_modules/primeflex/primeflex.css";
import "sweetalert2/dist/sweetalert2.min.css";
const app = createApp(App);
app.config.globalProperties.$toastTime = 3000;
app.use(router);
app.use(PrimeVue);
app.use(VueSweetalert2);
app.use(ToastService);
app.use(
  createGtm({
    id: process.env.VUE_APP_GTM_ID,
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: true, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  })
);
app.mount("#app");
app.config.globalProperties.$filters = {
  pluralizeAmount(value: number) {
    const sub = value > 1 ? "pesos" : "peso";
    return `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ${sub}`;
  },
  pluralizeMonths(value: number) {
    const sub = value > 1 ? "meses" : "mes";
    return `${value} ${sub}`;
  },
};
